<template>
  <b-modal
    :busy="isBusy"
    :ok-title="$t('general.save')"
    :title="title"
    :visible="visible"
    no-close-on-backdrop
    no-close-on-esc
    @hidden="close"
    @ok="onOk"
  >
    <fields layout="vertical" />
  </b-modal>
</template>

<script>
import { ResourceFormMixin } from 'stylemix-vue-admin'
import CurrenciesApi from './Api.js'

export default {
  mixins: [ResourceFormMixin],

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      code: null,
      isBusy: false,
    }
  },

  computed: {
    title() {
      return this.$t(this.id ? 'general.edit' : 'general.add_new')
    },
  },

  watch: {
    visible(newVal) {
      if (newVal) {
        this.loadForm()
      }
    },
  },

  methods: {
    api() {
      return new CurrenciesApi()
    },

    onOk(event) {
      event.preventDefault()
      this.submit()
    },

    submit() {
      this.isBusy = true
      this.save()
        .then((result) => {
          if (result.message) {
            this.$toast.success(result.message)
          }
        })
        .finally(() => {
          this.isBusy = false
        })
    },

    close() {
      this.$emit('update:visible', false)
    },
  },
}
</script>
